<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel modal__panel--service">
            <div class="modal__main-icon modal__main-icon--policy"></div>
            <div class="modal__back" @click="goBack()"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form">
                <div class="navigators">
                    <div class="navigator navigator--active">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addPolicyModal.${"title"}`) }}
                        </div>
                    </div>
                </div>

                <form v-if="teamId == null" class="add__form add__form--service" @submit.prevent>
                    <transition name="fade" mode="out-in">
                        <Loading v-if="isModalLoading" />
                        <div v-else class="add__content">
                            <div class="policy">
                                <div class="policy__form">
                                    <div class="policy__inputs">
                                        <div class="policy__column">
                                            <div class="form__field">
                                                <VSelect class="select select--default"
                                                    :placeholder="$t(`addPolicyModal.${'teams'}`)"
                                                    :class="{ 'select--error': teamIdHasError }" :options="fetchedTeams"
                                                    :reduce="(team) => team.id"
                                                    :getOptionLabel="(team) => `${team.name}`" v-model="teamId"
                                                    @update:modelValue="fetchPolicyData" />
                                                <div class="form__error" v-if="teamIdHasError">
                                                    {{ $t(`addPolicyModal.${"teamErrorMsg"}`) }}
                                                </div>
                                            </div>

                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default"
                                                    :placeholder="$t(`addPolicyModal.${'agent'}`)" />
                                            </div>
                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default"
                                                    :placeholder="$t(`addPolicyModal.${'company'}`)" />
                                            </div>
                                            <div class="form__field disabled-el">
                                                <input disabled type="text" class="input input--default"
                                                    :placeholder="$t(`addPolicyModal.${'policyNumber'}`)" />
                                            </div>
                                        </div>
                                        <div class="policy__column">
                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default"
                                                    :placeholder="$t(`addPolicyModal.${'agent'}`)" />
                                            </div>
                                            <div class="form__field disabled-el">
                                                <div class="mandat">
                                                    <label class="mandat__title" for="mandatCheckbox"> </label>
                                                    <div class="checkbox">
                                                        <input disabled type="checkbox" id="mandatCheckbox"
                                                            class="checkbox__checkbox" />
                                                        <label for="mandatCheckbox" class="checkbox__label"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default"
                                                    :placeholder="$t(`addPolicyModal.${'brokerageFirm'}`)" />
                                            </div>
                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default"
                                                    :placeholder="$t(`addPolicyModal.${'status'}`)" />
                                            </div>
                                        </div>
                                    </div>
                                    <DropFile class="disabled-el" :disabled="true" @input="files = $event" />
                                </div>
                            </div>
                        </div>
                    </transition>
                </form>

                <form v-else class="add__form add__form--service" @submit.prevent>
                    <transition name="fade" mode="out-in">
                        <Loading v-if="isModalLoading" />
                        <div v-else class="add__content">
                            <div class="policy">
                                <div class="policy__form">
                                    <div class="policy__inputs">
                                        <div class="policy__column">
                                            <div class="form__field">
                                                <div class="input input--default input--readonly">
                                                    {{ customerDetails?.team?.name }}
                                                </div>
                                            </div>

                                            <div class="form__field">
                                                <VSelect v-if="customerMembers?.length"
                                                    :class="{ disable: teamId == null }" class="select select--default"
                                                    :options="customerMembers" :reduce="(member) => member.id"
                                                    :getOptionLabel="(member) => parseCustomerName(member)"
                                                    v-model="policy.customerId" />
                                                <div v-else class="input input--default input--readonly">
                                                    {{ parseCustomerName(customerDetails) }}
                                                </div>
                                            </div>

                                            <div class="form__field">
                                                <VSelect
                                                    :class="{ disable: teamId == null, 'select--error': companyHasError }"
                                                    class="select select--default" :options="companies"
                                                    :reduce="(company) => company.id" v-model="companyId" label="name"
                                                    :placeholder="$t(`addPolicyModal.${'company'}`)" />
                                                <div class="form__error" v-if="companyHasError">
                                                    {{ $t(`addPolicyModal.${"companyErrorMsg"}`) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="policy__column">
                                            <div class="form__field">
                                                <VSelect :class="{ 'select--error': agentHasError }" :options="agents"
                                                    :reduce="(agent) => agent.id" class="select select--default"
                                                    :placeholder="$t(`addPolicyModal.${'agent'}`)"
                                                    v-model="policy.agentId"
                                                    :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`" />
                                                <div class="form__error" v-if="agentHasError">
                                                    {{ $t(`addPolicyModal.${"agentErrorMsg"}`) }}
                                                </div>
                                            </div>
                                            <div class="form__field">
                                                <div class="mandat">
                                                    <label class="mandat__title" for="mandatCheckbox"> {{
                                                        $t(`addPolicyModal.${"agentMandate"}`) }}</label>
                                                    <div class="checkbox">
                                                        <input :class="{ disable: teamId == null }" type="checkbox"
                                                            id="mandatCheckbox" class="checkbox__checkbox"
                                                            v-model="enableBrokerFirma" />
                                                        <label for="mandatCheckbox" class="checkbox__label"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form__field">
                                                <div class="mandat" v-if="policy.agentId">
                                                    <label class="mandat__title" for="begleittermin">
                                                        {{ $t(`addSaleCategoryModal.${"secondAgent"}`) }}
                                                    </label>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="begleittermin"
                                                            class="checkbox__checkbox" v-model="appoiment" />
                                                        <label for="begleittermin" class="checkbox__label"></label>
                                                    </div>
                                                </div>
                                                <div class="mandat disabled-el" v-else>
                                                    <label class="mandat__title" for="begleittermin">
                                                        {{ $t(`addSaleCategoryModal.${"secondAgent"}`) }}
                                                    </label>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="begleittermin"
                                                            class="checkbox__checkbox" disabled />
                                                        <label for="begleittermin"
                                                            class="checkbox__label disabled-el"></label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form__field" v-if="appoiment">
                                                <VSelect :class="{ 'select--error': agent2HasError }"
                                                    :options="filteredAgents" :reduce="(agent) => agent.id"
                                                    class="select select--default"
                                                    :placeholder="$t(`addPolicyModal.${'agent'}`)"
                                                    v-model="policy.agentId2"
                                                    :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`" />
                                                <div class="form__error" v-if="agent2HasError">
                                                    {{ $t(`addPolicyModal.${"agentErrorMsg"}`) }}
                                                </div>
                                            </div>
                                            <div class="form__field" v-if="appoiment">
                                                <VSelect :class="{ 'select--error': saleCategoryHasError }"
                                                    :options="agentSaleCategories" :reduce="(category) => category.id"
                                                    class="select select--default"
                                                    :placeholder="$t(`addPolicyModal.${'comission'}`)"
                                                    v-model="policy.saleCategory" :getOptionLabel="getCategoryLabel" />
                                                <div class="form__error" v-if="saleCategoryHasError">
                                                    {{ $t(`addPolicyModal.${"saleCategoryErrorMsg"}`) }}
                                                </div>
                                            </div>
                                            <div class="form__field">
                                                <template v-if="enableBrokerFirma">
                                                    <VSelect :class="{
                                                        disable: teamId == null,
                                                        'select--error': brokerCompanyHasError
                                                    }" class="select select--default" :options="brokerCompanies"
                                                        :reduce="(company) => company.id" label="name"
                                                        :placeholder="$t(`addPolicyModal.${'agentCompany'}`)"
                                                        v-model="policy.policyMandate.companyId" />

                                                    <div class="form__error" v-if="brokerCompanyHasError">
                                                        {{ $t("addPolicyModal.companyErrorMsg") }}
                                                    </div>
                                                </template>

                                                <div class="select select--default select--readonly" v-else>
                                                    {{ $t(`addPolicyModal.${"agentCompany"}`) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <PolicyDropFile v-model="files" :document-types="policyDocumentTypes"
                                    :show-save-button="false" />

                                <div v-if="showServices" class="policy__service-toggler">
                                    <span>{{ $t(`addPolicyModal.${'services'}`) }}</span>
                                    <div class="policy__service-adder" :class="{
                                        'policy__service-adder--active': showServicesDropdown,
                                    }" @click="showServicesDropdown = !showServicesDropdown"></div>

                                    <transition name="fade">
                                        <div class="service-dropdown" v-if="showServicesDropdown">
                                            <Loading v-if="servicesLoading" />
                                            <div v-else class="service-dropdown__content">
                                                <div class="service-dropdown__title">
                                                    {{ $t(`addPolicyModal.${"chooseServiceTitle"}`) }}
                                                </div>

                                                <div class="service-dropdown__search">
                                                    <input type="text" class="input input--default input--search"
                                                        :placeholder="$t(`addPolicyModal.${'searchServices'}`)"
                                                        v-model="serviceSearchQuery" />
                                                </div>

                                                <div class="service-dropdown__body">
                                                    <div v-if="!filteredServices.length"
                                                        class="service-dropdown__no-data">
                                                        {{ $t(`addPolicyModal.${"noServicesFound"}`) }}
                                                    </div>

                                                    <template v-else>
                                                        <div class="service-dropdown__item"
                                                            v-for="service in filteredServices" :key="service.id">
                                                            <div class="checkbox">
                                                                <input type="checkbox" class="checkbox__checkbox"
                                                                    :checked="services.some((s) => s.id === service.id)"
                                                                    :id="service.id"
                                                                    @change="addOrRemoveServices($event, service)" />
                                                                <label :for="service.id"
                                                                    class="checkbox__label checkbox__label--smaller"></label>
                                                            </div>
                                                            <label :for="service.id"
                                                                class="service-dropdown__item-title">
                                                                {{ service.name }}
                                                            </label>
                                                        </div>
                                                    </template>
                                                </div>

                                                <div class="service-dropdown__buttons">
                                                    <button type="button"
                                                        class="service-dropdown__button service-dropdown__button--submit"
                                                        @click="applyServices()"></button>
                                                    <button type="button"
                                                        class="service-dropdown__button service-dropdown__button--cancel"
                                                        @click="closeServicesDropdown()"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </transition>

                                    <span v-if="showServicesErr" class="service-error">{{
                                        $t(`addPolicyModal.${"serviceErrorMsg"}`) }}</span>
                                </div>

                                <div class="services" v-if="services && showServices">
                                    <Service v-for="service in services" :key="service.id" :service="service"
                                        :companyId="companyId" :deleteService="deleteService"
                                        :servicesToDelete="servicesToDelete" :options="policyStatuses"
                                        :serviceSelectionOrder="serviceSelectionOrder"
                                        :allSelectedServices="services" />
                                </div>
                            </div>
                        </div>
                    </transition>
                </form>
            </div>

            <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading">
            </div>
            <div v-else class="modal__buttons">
                <div v-if="teamId == null" class="disabled-el">
                    <button disabled type="button"
                        class="modal__button modal__button--submit modal__button--pend button button--default">
                        <span>{{ $t(`addPolicyModal.${"saveButtonOpenPendency"}`) }}</span>
                    </button>
                    <button type="button" disabled class="modal__button modal__button--submit button button--default">
                        <span>{{ $t(`addPolicyModal.${"saveButton"}`) }}</span>
                    </button>
                </div>
                <div v-else>
                    <button type="button" :disabled="!canCreatePolicy"
                        class="modal__button modal__button--submit modal__button--pend button button--default"
                        @click="continueToPendency = true; createPolicy();">
                        <span>{{ $t(`addPolicyModal.${"saveButtonOpenPendency"}`) }}</span>
                    </button>
                    <button type="button" :disabled="!canCreatePolicy"
                        class="modal__button modal__button--submit button button--default"
                        @click="continueToPendency = false; createPolicy()">
                        <span>{{ $t(`addPolicyModal.${"saveButton"}`) }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import statics from "@/statics";
import moment from "moment";
import Loading from "@/partials/Loading";
import Service from "@/components/AddPolicyModal/Service";
import DropFile from "@/components/DropFile";
import PolicyDropFile from "@/components/PolicyDropFile";
import { parseCustomerName } from "@/helpers/entityParsers";
import parseFieldErrors from "@/helpers/parseFieldErrors";
import { syncDuplicatePolicyNumberErrors } from "@/helpers/policyNumberValidation";
import { useI18n } from 'vue-i18n';

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();

defineOptions({
    name: "AddPolicyModal"
});

const store = useStore();

// Reactive Data Elements
const teamIdHasError = ref(false);
const teamId = ref(null);
const brokerCompanyHasError = ref(false);
const continueToPendency = ref(false);
const formLoading = ref(false);
const showServicesDropdown = ref(false);
const showServices = ref(false);
const enableBrokerFirma = ref(false);
const isRequesting = ref(false);
const servicesLoading = ref(false);
const dropdownServices = ref([]);
const serviceSearchQuery = ref("");
const companyId = ref(null);
const preServices = ref([]);
const services = ref([]);
const servicesToDelete = ref([]);
const appoiment = ref(false);
const files = ref([]);
const serviceSelectionOrder = ref([]); // Track which services are selected and in what order

const policy = reactive({
    customerId: "",
    companyId: "",
    agentId: null,
    agentId2: null,
    saleCategory: null,
    policyMandate: {
        companyId: "",
    },
    submissionDate: ""
});

const companyHasError = ref(false);
const agentHasError = ref(false);
const agent2HasError = ref(false);
const saleCategoryHasError = ref(false);
const specificErrors = ref([]);
const showServicesErr = ref(false);

// Computed Mapping Options (Vuex getters replacements)
const policyForms = computed(() => store.getters.policyForms);
const fetchedTeams = computed(() => store.getters.fetchedTeams);
const customerDetails = computed(() => store.getters.customerDetails);
const customerMembers = computed(() => store.getters.customerMembers);
const isModalLoading = computed(() => store.getters.isModalLoading);
const formModels = computed(() => store.getters.formModels);
const singleModel = computed(() => store.getters.singleModel);
const singletonFormModels = computed(() => store.getters.singletonFormModels); 
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);

const companies = computed(() => policyForms.value?.companies || []);
const brokerCompanies = computed(() => policyForms.value?.['broker-companies'] || []);
const agents = computed(() => policyForms.value?.agents || []);
const policyStatuses = computed(() => policyForms.value?.['policy-statuses'] || []);
const policyDocumentTypes = computed(() =>
    policyForms.value?.['policy-document-types']
    || policyForms.value?.['document-types']
    || []
);
const agentSaleCategories = computed(() => {
    const selectedAgentId = Number(policy.agentId2);
    if (!selectedAgentId) return [];

    const selectedAgent = (Array.isArray(agents.value) ? agents.value : []).find(
        (agent) => Number(agent.id) === selectedAgentId
    );

    return Array.isArray(selectedAgent?.second_sales_category)
        ? selectedAgent.second_sales_category
        : [];
});

const filteredAgents = computed(() => {
    return (Array.isArray(agents.value) ? agents.value : []).filter((agent) => agent.id !== policy.agentId);
});

const canCreatePolicy = computed(() => {
    if (isSuperAdmin.value) return true;

    const candidate = teamId.value ?? customerDetails.value?.team?.id ?? customerDetails.value?.team_id;
    const parsed = Number(candidate);
    return Number.isInteger(parsed) && parsed > 0
        && store.getters.hasTeamPermission("policy_create", parsed);
});

const filteredServices = computed(() => {
    if (!dropdownServices.value) return [];
    return dropdownServices.value.filter((service) => {
        const title = service.name || "";
        return title.toLowerCase().includes(serviceSearchQuery.value.toLowerCase());
    });
});

// Watch Logic Rules
watch(companyId, async (id) => {
    if (id) {
        companyHasError.value = false;
        showServices.value = true;
        servicesLoading.value = true;
        services.value = [];
        preServices.value = [];
        policy.companyId = id;

        if (formModels.value?.length) {
            store.commit("setFormModels", []);
        }
        if (singleModel.value) {
            store.commit("setSingleModel", {
                ...singleModel.value,
                id: "",
                serviceId: "",
                startDate: "",
                franchise: "",
                accident: "",
                doctorName: "",
                price: "",
                interval: "",
                startDateHasError: false,
                priceHasError: false,
            });
        }
        if (singletonFormModels.value?.length) {
            store.commit("setSingletonFormModels", []);
        }
        try {
            dropdownServices.value = await store.dispatch("getCompanyServices", id);
        } catch (err) {
            console.error("Failed to load company services:", err);
            dropdownServices.value = [];
        } finally {
            servicesLoading.value = false;
        }
    } else {
        companyHasError.value = true;
        showServices.value = false;
    }
});

watch(() => policy.agentId, (id) => {
    if (id) {
        agentHasError.value = false;
        policy.agentId2 = null;
        policy.saleCategory = null;
    } else {
        agentHasError.value = true;
    }
});

watch(() => policy.agentId2, (id) => {
    agent2HasError.value = !id;
});

watch(() => policy.saleCategory, (id) => {
    saleCategoryHasError.value = !id;
});

watch(customerDetails, async () => {
    await hydrateFromCustomerDetails();
}, { deep: true });
watch(() => policy.policyMandate.companyId, (id) => {
    brokerCompanyHasError.value = !id && enableBrokerFirma.value;
});
// Methods
const getCategoryLabel = (category) => {
    if (!category) return '—';
    const name = category?.name;

    return name || '—';
};

const fetchPolicyData = async (selectedTeamId) => {
    if (selectedTeamId) {
        teamIdHasError.value = false;
        await store.dispatch("getPolicyForms", selectedTeamId);
    }
};

const hydrateFromCustomerDetails = async () => {
    const customerTeamId = customerDetails.value?.team?.id;

    if (customerDetails.value?.id) {
        policy.customerId = customerDetails.value.id;
    }

    if (!customerTeamId) {
        return;
    }

    const parsedCustomerTeamId = Number(customerTeamId);
    if (!isSuperAdmin.value && !store.getters.hasTeamPermission("policy_create", parsedCustomerTeamId)) {
        closeModal();
        return;
    }

    if (teamId.value === parsedCustomerTeamId) {
        return;
    }

    teamId.value = parsedCustomerTeamId;

    const shouldHandleLoading = !formLoading.value;
    if (shouldHandleLoading) {
        formLoading.value = true;
    }

    try {
        await fetchPolicyData(teamId.value);
    } finally {
        if (shouldHandleLoading) {
            formLoading.value = false;
        }
    }
};

const resetPolicyModalState = () => {
    store.commit("setFormModels", []);
    store.commit("setSingletonFormModels", []);
    store.commit("setSingleModel", {
        id: "",
        policy_number: "",
        policy_numberHasError: false,
        branch_category_id: "",
        policy_status_id: "",
        policy_statusHasError: false,
        serviceId: "",
        submit_date: null,
        submit_dateHasError: false,
        startDate: "",
        endDate: "",
        franchise: "",
        accident: "",
        doctorName: "",
        price: "",
        interval: "",
        plateNumber: "",
        startDateHasError: false,
        priceHasError: false,
    });
    store.commit("setServicesToRemove", []);
    store.commit("setSelectedService", {});

    teamId.value = null;
    companyId.value = null;
    serviceSearchQuery.value = "";
    services.value = [];
    preServices.value = [];
    serviceSelectionOrder.value = [];
    servicesToDelete.value = [];
    dropdownServices.value = [];
    showServices.value = false;
    showServicesDropdown.value = false;
    showServicesErr.value = false;
    appoiment.value = false;
    enableBrokerFirma.value = false;
    files.value = [];
    continueToPendency.value = false;
    teamIdHasError.value = false;
    companyHasError.value = false;
    agentHasError.value = false;
    agent2HasError.value = false;
    saleCategoryHasError.value = false;
    brokerCompanyHasError.value = false;
    policy.customerId = "";
    policy.companyId = "";
    policy.agentId = null;
    policy.agentId2 = null;
    policy.saleCategory = null;
    policy.policyMandate.companyId = "";
    policy.submissionDate = "";
};

const closeModal = () => {
    resetPolicyModalState();
    store.commit("setPolicyIsConverting", false);
    store.commit("setConvertingPolicyData", {});
    store.commit("setPolicyModalLoading", false);
    store.commit("setShowAddPolicyModal", false);
};

const goBack = () => {
    // TODO: Implement proper page navigation if needed
    closeModal();
    store.commit("setShowAddCustomerServicesModal", true);
};

const addOrRemoveServices = (event, service) => {
    if (event.target.checked) {
        preServices.value.push(service);
        // Track selection order
        if (!serviceSelectionOrder.value.includes(service.id)) {
            serviceSelectionOrder.value.push(service.id);
        }
    } else {
        preServices.value = preServices.value.filter((s) => s.id !== service.id);
        // Remove from selection order
        serviceSelectionOrder.value = serviceSelectionOrder.value.filter((id) => id !== service.id);
    }
};

const applyServices = () => {
    services.value = [...preServices.value];
    showServicesDropdown.value = false;
    // Selection order is already tracked in serviceSelectionOrder
};

const closeServicesDropdown = () => {
    preServices.value = [...services.value];
    showServicesDropdown.value = false;
};

const deleteService = (serviceId) => {
    services.value = services.value.filter((s) => s.id !== serviceId);
    preServices.value = preServices.value.filter((s) => s.id !== serviceId);
    // Remove from selection order
    serviceSelectionOrder.value = serviceSelectionOrder.value.filter((id) => id !== serviceId);
};

const validatePolicyFields = (callback) => {
    const {
        agentId,
        companyId,
        agentId2,
        saleCategory
    } = policy;

    if (services.value.length == 0) {
        showServicesErr.value = true;
    } else {
        showServicesErr.value = false;
    }

    if (!companyId) {
        companyHasError.value = true;
    }
    if (!agentId) {
        agentHasError.value = true;
    }
    if (enableBrokerFirma.value && !policy.policyMandate.companyId) {
        brokerCompanyHasError.value = true;
    }
    if (appoiment.value) {
        if (!agentId2) {
            agent2HasError.value = true;
        }

        if (!saleCategory) {
            saleCategoryHasError.value = true;
        }
    }

    const brokerCompanyValid =
        !enableBrokerFirma.value || policy.policyMandate.companyId;

    const agent2Valid = !appoiment.value || (agentId2 && !agent2HasError.value);
    const saleCategoryValid = !appoiment.value || (saleCategory && !saleCategoryHasError.value);

    if (
        services.value.length > 0 &&
        companyId &&
        agentId &&
        brokerCompanyValid &&
        agent2Valid &&
        saleCategoryValid
    ) {
        callback(true);
    } else {
        callback(false);
    }
};

const validateModelFields = (callback) => {
    const finalFormModels = formModels.value || [];
    const finalSingletons = singletonFormModels.value || [];
    const finalSingleModel = singleModel.value;
    const KVG = statics.KVG;

    // Get active service IDs
    const activeServiceIds = services.value.map(s => s.id);

    // Filter models to only include those for active services
    const activeFormModels = finalFormModels.filter(m => activeServiceIds.includes(m.serviceId));
    const activeSingletons = finalSingletons.filter(m => activeServiceIds.includes(m.serviceId));

    const hasKvg = services.value.some(service => service.id === KVG);
    const kvgIsSingleton = activeSingletons.some(m => m.serviceId === KVG);
    const policyNumberModels = [
      ...(finalSingleModel && finalSingleModel.serviceId ? [finalSingleModel] : []),
      ...activeFormModels,
      ...activeSingletons,
    ];

    syncDuplicatePolicyNumberErrors(policyNumberModels);

    // 1. FORCE BRANCH SYNCHRONIZATION
    const branchDataMap = {};

    [finalSingleModel, ...activeFormModels, ...activeSingletons].forEach(m => {
        if (m && m.policy_status_id && !branchDataMap[m.branch_category_id]) {
            branchDataMap[m.branch_category_id] = {
                status: m.policy_status_id,
                number: m.policy_number,
                date: m.submit_date,
            };
        }
    });

    let allFieldsAreValid = true;

    // 2. Validate Form Models (VVG / Multiple)
    activeFormModels.forEach((model) => {
        const originalIndex = finalFormModels.indexOf(model);
        if (branchDataMap[model.branch_category_id]) {
            model.policy_status_id = branchDataMap[model.branch_category_id].status;
            model.policy_number = branchDataMap[model.branch_category_id].number;
            model.submit_date = branchDataMap[model.branch_category_id].date;
        }

        const hasStartError = !model.startDate || (model.endDate && moment(model.startDate).isAfter(moment(model.endDate)));
        const hasPriceError = !model.price || model.price < 0 || statics.stringRegex.test(model.price) || statics.symbolRegex.test(model.price);
        const hasStatusError = !model.policy_status_id;
        const hasSubmissionDateError = model.policy_status_id === 1 && !model.submit_date;
        const hasDuplicatePolicyNumberError = model.policy_numberHasError;

        if (hasStartError || hasPriceError || hasStatusError || hasSubmissionDateError || hasDuplicatePolicyNumberError) {
            allFieldsAreValid = false;
        }

        store.commit("setSpecificFormModel", { index: originalIndex, key: "startDateHasError", data: hasStartError });
        store.commit("setSpecificFormModel", { index: originalIndex, key: "priceHasError", data: hasPriceError });
        store.commit("setSpecificFormModel", { index: originalIndex, key: "policy_statusHasError", data: hasStatusError });
        store.commit("setSpecificFormModel", { index: originalIndex, key: "submit_dateHasError", data: hasSubmissionDateError });
    });

    // 3. Validate Singletons
    activeSingletons.forEach((model) => {
        const originalIndex = finalSingletons.indexOf(model);
        const hasStartError = !model.startDate || (model.endDate && moment(model.startDate).isAfter(moment(model.endDate)));
        const hasPriceError = (!model.price || model.price < 0 || statics.stringRegex.test(model.price) || statics.symbolRegex.test(model.price)) && model.serviceId != 32;
        const hasStatusError = !model.policy_status_id;
        const hasSubmissionDateError = model.policy_status_id === 1 && !model.submit_date;
        const hasDuplicatePolicyNumberError = model.policy_numberHasError;

        if (hasStartError || hasPriceError || hasStatusError || hasSubmissionDateError || hasDuplicatePolicyNumberError) {
            allFieldsAreValid = false;
        }

        store.commit("setSpecificSingletonFormModel", { index: originalIndex, key: "startDateHasError", data: hasStartError });
        store.commit("setSpecificSingletonFormModel", { index: originalIndex, key: "priceHasError", data: hasPriceError });
        store.commit("setSpecificSingletonFormModel", { index: originalIndex, key: "policy_statusHasError", data: hasStatusError });
        store.commit("setSpecificSingletonFormModel", { index: originalIndex, key: "submit_dateHasError", data: hasSubmissionDateError });
    });

    // 4. Validate KVG singleModel
    if (hasKvg && !kvgIsSingleton && finalSingleModel) {
        const hasStartError = !finalSingleModel.startDate || (finalSingleModel.endDate && moment(finalSingleModel.startDate).isAfter(moment(finalSingleModel.endDate)));
        const hasPriceError = !finalSingleModel.price || finalSingleModel.price < 0;
        const hasStatusError = !finalSingleModel.policy_status_id;
        const hasSubmissionDateError = finalSingleModel.policy_status_id === 1 && !finalSingleModel.submit_date;
        const hasDuplicatePolicyNumberError = finalSingleModel.policy_numberHasError;

        if (hasStartError || hasPriceError || hasStatusError || hasSubmissionDateError || hasDuplicatePolicyNumberError) {
            allFieldsAreValid = false;
        }

        store.commit("setSpecificSingleModel", { key: "startDateHasError", data: hasStartError });
        store.commit("setSpecificSingleModel", { key: "priceHasError", data: hasPriceError });
        store.commit("setSpecificSingleModel", { key: "policy_statusHasError", data: hasStatusError });
        store.commit("setSpecificSingleModel", { key: "submit_dateHasError", data: hasSubmissionDateError });
    }

    // 5. Final check now reflects what was actually computed above,
    // not a re-read of possibly-stale objects.
    isRequesting.value = !allFieldsAreValid ? false : isRequesting.value;
    callback(allFieldsAreValid);
};

const openAddNewPendency = (policy) => {
    if (!policy) {
        return;
    }

    const agentId = policy.agent?.id || policy.agent_id;
    if (!agentId && !policy.id) {
        return;
    }

    store.commit("setShowAddActivityModal", false);
    closeModal();
    store.commit("setShowAddPendencyModal", true);
    store.commit("setFromPolicyId", policy.id);
    if (agentId) {
        store.commit("setFromPolicyAgentId", agentId);
    }
};

const createPolicy = async () => {
    const activeTeamId = teamId.value ?? customerDetails.value?.team?.id ?? customerDetails.value?.team_id;
    if (!isSuperAdmin.value && (!activeTeamId || !store.getters.hasTeamPermission("policy_create", Number(activeTeamId)))) {
        closeModal();
        return;
    }

    isRequesting.value = true;
    const teamIdValue = teamId.value;

    validatePolicyFields(async (policyState) => {
        validateModelFields(async (modelsState) => {
            if (!policyState || !modelsState || !services.value.length) {
                isRequesting.value = false;
                return;
            }

            const KVG = statics.KVG;
            const hasKVG = services.value.some(s => s.id === KVG);
            const kvgIsSingleton = singletonFormModels.value?.find(s => s.serviceId === KVG);

            const formatDate = (dateVal) => {
                if (!dateVal && dateVal !== 0) return null;

                if (dateVal instanceof Event) {
                    dateVal = dateVal.target?.value || null;
                    if (!dateVal) return null;
                }

                if (Array.isArray(dateVal)) {
                    if (dateVal.length === 0) return null;
                    dateVal = dateVal[0];
                }

                if (dateVal instanceof Date) {
                    if (isNaN(dateVal.getTime())) {
                        return null;
                    }
                    return moment(dateVal).format("YYYY-MM-DD");
                }

                if (typeof dateVal === 'string' && dateVal.trim()) {
                    const formats = ['DD.MM.YYYY', 'YYYY-MM-DD', 'MM/DD/YYYY', 'DD/MM/YYYY', 'DD-MM-YYYY'];
                    for (let fmt of formats) {
                        const attempt = moment(dateVal, fmt, true);
                        if (attempt.isValid()) {
                            return attempt.format("YYYY-MM-DD");
                        }
                    }

                    const parsed = moment(dateVal);
                    if (parsed.isValid()) {
                        return parsed.format("YYYY-MM-DD");
                    }
                    return dateVal;
                }

                return dateVal;
            };

            // Filter to only include models for active services
            const activeServiceIds = services.value.map(s => s.id);

            const policyServices = [
                ...formModels.value
                    .filter(model => activeServiceIds.includes(model.serviceId))
                    .map(model => ({
                        service_id: model.serviceId,
                        service_model_id: model.id,
                        start_date: formatDate(model.startDate),
                        end_date: formatDate(model.endDate),
                        premium_interval_id: model.interval,
                        franchise: model.franchise,
                        accident: model.accident,
                        premium: Number(model.price),
                        model_category_id: model.economy,
                        plate_number: model.plateNumber || "",
                        policy_number: model.policy_number,
                        policy_status_id: model.policy_status_id,
                        submit_date: formatDate(model.submit_date),
                    })),
                ...singletonFormModels.value
                    .filter(s => activeServiceIds.includes(s.serviceId))
                    .map(s => ({
                        service_id: s.serviceId,
                        service_model_id: s.id || null,
                        start_date: formatDate(s.startDate),
                        end_date: formatDate(s.endDate),
                        premium_interval_id: s.interval,
                        franchise: s.franchise,
                        accident: s.accident,
                        premium: Number(s.price),
                        model_category_id: s.economy,
                        plate_number: s.plateNumber || "",
                        policy_number: s.policy_number,
                        policy_status_id: s.policy_status_id,
                        submit_date: formatDate(s.submit_date),
                    })),
                ...(hasKVG && !kvgIsSingleton ? [{
                    service_id: singleModel.value.serviceId,
                    service_model_id: singleModel.value.id,
                    start_date: formatDate(singleModel.value.startDate),
                    end_date: formatDate(singleModel.value.endDate),
                    premium_interval_id: singleModel.value.interval,
                    franchise: singleModel.value.franchise,
                    accident: singleModel.value.accident,
                    premium: Number(singleModel.value.price),
                    model_category_id: singleModel.value.economy,
                    plate_number: singleModel.value.plateNumber || "",
                    policy_number: singleModel.value.policy_number,
                    policy_status_id: singleModel.value.policy_status_id,
                    submit_date: formatDate(singleModel.value.submit_date),
                }] : [])
            ];

            try {
                const response = await store.dispatch("addPolicy", {
                    customerId: policy.customerId,
                    companyId: policy.companyId,
                    agentId: policy.agentId,
                    agentId2: policy.agentId2,
                    saleCategory: policy.saleCategory,
                    policyMandate: policy.policyMandate,
                    policyServices,
                    submissionDate: moment().format("YYYY-MM-DD"),
                    teamId: teamIdValue,
                    formModels: formModels.value || [],
                    singletonFormModels: singletonFormModels.value || [],
                    singleModel: hasKVG && !kvgIsSingleton ? singleModel.value : null,
                });

                let policyData = response.data;

                while (policyData && typeof policyData === 'object' && policyData.data && !policyData.id) {
                    policyData = policyData.data;
                }

                if (Array.isArray(policyData)) {
                    policyData = policyData[0];
                }

                if (files.value.length > 0 && policyData?.id) {
                    try {
                        const createdFilesResponse = await store.dispatch("addPolicyFile", {
                            policyId: policyData.id,
                            files: files.value,
                        });

                        const createdFiles = Array.isArray(createdFilesResponse)
                            ? createdFilesResponse
                            : Array.isArray(createdFilesResponse?.data)
                                ? createdFilesResponse.data
                                : Array.isArray(createdFilesResponse?.files)
                                    ? createdFilesResponse.files
                                    : [];

                        await Promise.all(
                            (Array.isArray(files.value) ? files.value : []).map(async (fileEntry, index) => {
                                const uuid = createdFiles[index]?.uuid || createdFiles[index]?.id || null;
                                const documentTypeId = fileEntry?.documentTypeId ?? fileEntry?.document_type_id ?? fileEntry?.documentType?.id ?? null;

                                if (uuid && documentTypeId !== null && documentTypeId !== undefined) {
                                    await store.dispatch("updateMediaDocumentType", {
                                        uuid,
                                        documentTypeId,
                                    });
                                }
                            })
                        );
                    } catch (fileErr) {
                        // Error already handled by store action
                    }
                }

                if (continueToPendency.value) {
                    openAddNewPendency(policyData);
                } else {
                    closeModal();
                    await store.dispatch("getGlobalCustomer", customerDetails.value.id);
                }

            } catch (err) {
                if (err.response?.data?.errors) {
                    specificErrors.value = parseFieldErrors(err.response.data.errors);
                }
            } finally {
                isRequesting.value = false;
            }
        });
    });
};

// Lifecycle Trigger Hooks
onMounted(async () => {
    await hydrateFromCustomerDetails();
});
</script>

<style lang="scss" scoped>
.modal__panel--service {
    height: 90%;
    top: 2%;
}  

.modal__buttons {
    width: 100%;
}

.modal__button--pend {
    margin-right: 250px;
    width: 220px;
}

.policy__service-adder {
    margin-right: 25px;
}

.policy__files-preview {
    margin-top: 16px;
    padding: 12px 14px;
    border-radius: 10px;
    background: var(--bg-3);
    border: 1px solid var(--border-10);
}

.policy__files-preview-title {
    margin-bottom: 8px;
    color: var(--text-2);
    font-size: var(--x-smaller);
    font-family: var(--muli-text-semi-bold);
}

.policy__file-preview-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid var(--border-10);
    color: var(--text-2);
    font-size: var(--x-smaller);
}

.policy__file-preview-item:last-child {
    border-bottom: none;
}

.policy__file-preview-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.policy__file-preview-type {
    color: var(--text-5);
    white-space: nowrap;
}

.disabled-el {
    .mandat {
        .checkbox {
            label {
                border: 1px solid #7F8FA480;
            }
        }
    }

    label {
        color: #7F8FA480 !important;
    }
}

.policy {
    padding-bottom: 30px;
    box-shadow: none;

    &__form {
        display: flex;
        //border-bottom: 1px solid var(--border-10);
        padding-bottom: 20px;
    }

    &__inputs {
        flex: 1;
        display: flex;
    }

    &__column {
        margin-right: 10px;
        flex: 1;

        .form__field {
            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .mandat {
        display: flex;
        align-items: center;
        margin: 31px 10px;

        &__title {
            color: var(--text-2);
            font-family: var(--muli-text-semi-bold);
            margin-right: 10px;
        }
    }

    :deep(.policy__service-toggler) {
        position: relative;
        margin: 15px 0;
        padding-right: 20px;
        display: inline-flex;
        align-items: center;

        span {
            color: var(--text-2);
            font-size: var(--x-small);
            font-family: var(--muli-text-semi-bold);
        }
    }

    :deep(.policy__service-adder) {
        width: 24px;
        height: 24px;
        background: var(--bg-2);
        margin-left: 22px;
        border-radius: var(--radius-3);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:before {
            content: "";
            display: block;
            width: 15px;
            height: 15px;
            background: url("../assets/icons/default/add_icon.svg") no-repeat center;
            background-size: 15px;
            transition: all 0.3s ease;
        }

    }

    :deep(.policy__service-adder--active:before),
    :deep(.policy__service-adder:hover:before) {
        transform: rotate(180deg);
    }

    :deep(.service-dropdown) {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 100%;
        min-height: 265px;
        background: var(--bg-1);
        padding: 10px 20px;
        border: 1px solid var(--border-2);
        border-radius: var(--radius-1);
        box-shadow: 0px 3px 30px var(--shadow-4);
        width: 400px;
        transition: all 0.3s ease;
    }

    :deep(.service-dropdown__title) {
        color: var(--text-5);
        margin-bottom: 10px;
    }

    :deep(.service-dropdown__search) {
        margin-bottom: 15px;

        .input--search {
            width: 100%;
            height: 35px;
            font-size: var(--x-small);
        }
    }

    :deep(.service-dropdown__item) {
        display: flex;
        align-items: center;
        font-size: var(--x-small);
        color: var(--text-2);
        padding: 6px 0;
    }

    :deep(.service-dropdown__item-title) {
        margin-left: 10px;
    }

    :deep(.service-dropdown__content) {
        position: relative;
    }

    :deep(.service-dropdown__body) {
        max-height: 176px;
        overflow: auto;
        margin-bottom: 10px;
    }

    :deep(.service-dropdown__buttons) {
        display: flex;
        justify-content: flex-end;
    }

    :deep(.service-dropdown__button) {
        width: 44px;
        height: 27px;
        border-radius: var(--radius-1);
    }

    :deep(.service-dropdown__button--submit) {
        background-color: var(--bg-2);
        margin-right: 20px;
        background-image: url("../assets/icons/default/tick_icon.svg");
    }

    :deep(.service-dropdown__button--cancel) {
        background: var(--bg-12);
        background-image: url("../assets/icons/default/x_icon_white.svg");
    }

    :deep(.service-dropdown__button--submit),
    :deep(.service-dropdown__button--cancel) {
        background-repeat: no-repeat;
        background-size: 15px;
        background-position: center;
    }

    .services {
        border-top: 1px solid var(--border-10);
        overflow: initial !important;
    }

    .service-dropdown__no-data {
        color: var(--text-2);
    }
}
</style>